import { LoadingButton } from "@mui/lab";
import {
    Box,
    Divider,
    Icon,
    IconButton,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { ChangeEvent, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SaleActivityType, SaleStatus } from "../../../api/psc";
import { AppDatePicker, MultiSelect } from "../../../components/exports";
import { SaleStatusConstants } from "../../../constants/SaleConstants";
import { DialogContext } from "../../../contexts/DialogContext";
import {
    resetAndFetchActivities,
    setActivitiesFilter,
} from "../../../slices/ActivitySlice";
import { RootState } from "../../../slices/Store";

export default function ActivityFilter(props: { type: SaleActivityType }) {
    const dispatch = useDispatch();
    const activityState = useSelector(
        (state: RootState) => state.activityState
    );

    const { closeDialog } = useContext(DialogContext);

    const applyFilter = () => {
        resetAndFetchActivities(props.type, activityState, dispatch);
    };

    const handleSelectUser = (userIds: number[]) => {
        dispatch(
            setActivitiesFilter({ ...activityState.filter, userIds: userIds })
        );
    };

    const handleStatusChange = (values: SaleStatus[]) => {
        const filter = { ...activityState.filter, statuses: values };
        dispatch(setActivitiesFilter(filter));
    };

    const handleCreateDateFrom = (date: string) => {
        const filter = { ...activityState.filter, createDateFrom: date };
        dispatch(setActivitiesFilter(filter));
    };

    const handleCreateDateTo = (date: string) => {
        const filter = { ...activityState.filter, createDateTo: date };
        dispatch(setActivitiesFilter(filter));
    };

    const handleDueDateFrom = (date: string) => {
        const filter = { ...activityState.filter, dueDateFrom: date };
        dispatch(setActivitiesFilter(filter));
    };

    const handleDueDateTo = (date: string) => {
        const filter = { ...activityState.filter, dueDateTo: date };
        dispatch(setActivitiesFilter(filter));
    };

    const handleTermChange = (
        elem: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const filter = { ...activityState.filter, term: elem.target.value };
        dispatch(setActivitiesFilter(filter));
    };

    const listUserItem = activityState.users.map((u) => {
        return { id: u.id, title: u.displayName };
    });

    return (
        <Box sx={{ p: 2 }}>
            <Stack spacing={2}>
                <Stack spacing={1} direction="row" alignItems="end">
                    <Typography sx={{ flexGrow: 1 }}>
                        فیلتر فعالیت ها
                    </Typography>

                    <LoadingButton
                        onClick={applyFilter}
                        endIcon={<Icon>filter_alt</Icon>}
                        loading={activityState.isFetching}
                        variant="contained"
                    >
                        اعمال فیلتر
                    </LoadingButton>

                    <IconButton
                        onClick={closeDialog}
                        sx={{ display: { md: "none", sm: "block" } }}
                    >
                        <Icon>close</Icon>
                    </IconButton>
                </Stack>

                <Divider />

                <MultiSelect
                    label="کاربران"
                    values={listUserItem}
                    selectedIds={activityState.filter.userIds}
                    onValueChange={handleSelectUser}
                />
                {props.type !== SaleActivityType.NOTE && (
                    <>
                        <MultiSelect
                            label="وضعیت"
                            values={SaleStatusConstants}
                            selectedIds={activityState.filter.statuses}
                            onValueChange={handleStatusChange}
                        />
                    </>
                )}

                <AppDatePicker
                    label="تاریخ ایجاد از"
                    onChange={handleCreateDateFrom}
                    initialValue={activityState.filter.createDateFrom}
                />

                <AppDatePicker
                    label="تاریخ ایجاد تا"
                    onChange={handleCreateDateTo}
                    initialValue={activityState.filter.createDateTo}
                />

                {props.type === SaleActivityType.REMINDER && (
                    <>
                        <AppDatePicker
                            label="تاریخ یادآوری از"
                            onChange={handleDueDateFrom}
                            initialValue={activityState.filter.dueDateFrom}
                        />

                        <AppDatePicker
                            label="تاریخ یادآوری تا"
                            onChange={handleDueDateTo}
                            initialValue={activityState.filter.dueDateTo}
                        />
                    </>
                )}

                <TextField
                    fullWidth
                    value={activityState.filter.term}
                    onChange={handleTermChange}
                    label="جستجو"
                    placeholder={"جستجو در فعالیت ها"}
                    variant="outlined"
                />
            </Stack>
        </Box>
    );
}
